/* Response Time CSS */

export default theme => ({

})